

























































import { Component, Vue, Watch } from 'vue-property-decorator'
import { RouteRecord } from 'vue-router'
import {
  home,
  moment,
  assessment,
  application,
  message,
  manage,
  teacherStudent,
  setting,
} from '@/router'
import { MessageController } from '@/services/request.service'
import { getSchoolInfo } from '@/utils/utils'

@Component
export default class PadMenu extends Vue {
  public menuKeys: Array<string> = []
  public menuOpenKeys: Array<string> = ['assessment']
  public newMessage = 0

  @Watch('$route', { immediate: true })
  public onRouteChanged(to: any, from: any) {
    this.getMessage()
  }

  public get subRoutes(): any {
    return this.$store.state.routes[0].children.filter(child => !child.hidden)
  }

  public get routes(): Array<any> {
    const router = this.$route as any
    return router.matched.filter((item: RouteRecord) => item.meta && item.meta.routerName)
  }

  public get roleType(): string {
    return this.$store.state.roleType
  }

  public get schoolId(): number {
    return getSchoolInfo().schoolId
  }

  public get menus(): Array<object> {
    return this.subRoutes
  }

  public created(): void {
    const routes = this.routes
    this.menuOpenKeys = routes[2]
      ? [routes[1].meta.routerName, routes[0].meta.routerName]
      : routes[1]
      ? [routes[0].meta.routerName]
      : []
    this.menuKeys = routes[2]
      ? [routes[2].meta.routerName]
      : routes[1]
      ? [routes[1].meta.routerName]
      : [routes[0].meta.routerName]
  }

  public getMessage(): void {
    MessageController.hasUnRead()
      .then(res => {
        if (res.data) {
          this.newMessage = 1
        } else {
          this.newMessage = 0
        }
      })
      .catch(err => {
        console.error(err)
      })
  }

  public clickTopMenu({ key }: { key: string }): void {
    this.$router.push({ name: key }).catch(err => {})
  }
}
